import { render, staticRenderFns } from "./super.vue?vue&type=template&id=a6c12166&scoped=true&"
import script from "./super.vue?vue&type=script&lang=js&"
export * from "./super.vue?vue&type=script&lang=js&"
import style0 from "./super.vue?vue&type=style&index=0&id=a6c12166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c12166",
  null
  
)

export default component.exports